<template>
  <div class="card-item transaction shadowless">
    <div id="process-result-item" data-cy="process-result-item" class="entity-main-data">
      <div :id="`item-tag-${pos}`" :data-cy="`item-tag-${pos}`" class="movement-type field is-grouped item">
        <span v-if="appraisal.processingStatus == 'SAVED'" id="appraisal-saved-tag" class="tag is-medium is-success is-light">
          Creado
        </span>
        <span v-if="appraisal.processingStatus == 'PROCESSED'" id="appraisal-processed-tag" data-cy="appraisal-processed-tag" class="tag is-medium is-success is-light">
          Procesado
        </span>
        <div v-if="appraisal.processingStatus == 'TO_AMEND'" class="tag-and-counter">
          <span id="appraisal-toamend-tag" data-cy="appraisal-toamend-tag" class="tag is-medium is-warning is-light">
            Por Enmendar
          </span>
          <b-field>
            <b-tag rounded type="is-warning">{{ appraisal.processingTransactionsResult.transactionsToAmend.length }}</b-tag>
          </b-field>
        </div>
      </div>
      <div class="item">
        <span class="title"> Cliente </span>
        <span>{{ appraisal.investorName }}</span>
      </div>
      <div class="item">
        <span class="title">Fecha endoso</span>
        <span>{{ appraisal.salesDate }}</span>
      </div>
      <div class="item">
        <span class="title">Tipo</span>
        <span>{{ appraisal.salesType }}</span>
      </div>
      <div class="item">
        <span class="title">Nro. Operaciones</span>
        <span>{{ appraisal.totalOperations }}</span>
      </div>
      <div class="item">
        <span class="title">Fecha de creación</span>
        <span>{{ appraisal.createdAt.split('T')[0] }}</span>
      </div>
      <div class="item">
        <span class="title">Valor</span>
        <span>UF {{ formatNumber(appraisal.totalAmountAwarded) }}</span>
      </div>
      <div class="extend-button">
        <a
          v-if="appraisal.processingStatus == 'TO_AMEND'"
          :id="`extend-button-${pos}`"
          :data-cy="`extend-button-${pos}`"
          href="#"
          class="text-not-underline"
          @click.prevent="showDetails(pos)">
          <span class="icon">
            <i
              class="fas fa-chevron-up transition-slow"
              :class="{rotate: extendedEntity !== pos}" />
          </span>
        </a>
      </div>
    </div>
    <div
      :id="`extended-detail-${pos}`"
      :data-cy="`extended-detail-${pos}`"
      class="entity-detailed-data content transition-slow"
      :class="{ show: extendedEntity === pos }">
      <appraisal-history-transaction-item
        v-for="(transaction, i) in appraisal.processingTransactionsResult.transactionsToAmend"
        :id="`item-${i}`"
        :key="`${transaction}-${i}`"
        :appraisal-id="appraisal._id"
        :transaction="transaction"
        :pos="i"
        class="entity-details"
        :style="{ '--i': i }"
        @updateAppraisalStatus="updateAppraisalStatus"
        @updateTransactionStatus="updateTransactionStatus" />
    </div>
  </div>
</template>

<script>
import AppraisalHistoryTransactionItem from '@/ui/views/internal/trading/AppraisalHistoryTransactionItem.vue';
import { formatNumber } from '@/infrastructure/format';

export default {
  name: 'AppraisalItem',
  components: { AppraisalHistoryTransactionItem },
  props: {
    appraisal: {
      type: Object,
      default: () => {},
      required: true
    },
    pos: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      extendedEntity: undefined
    };
  },

  methods: {
    formatNumber: number => formatNumber({ number }),
    showDetails(pos) {
      this.extendedEntity = this.extendedEntity !== pos ? pos : undefined;
    },
    updateAppraisalStatus(status) {
      this.appraisal.processingStatus = status;
    },
    updateTransactionStatus(pos) {
      this.appraisal.processingTransactionsResult.transactionsToAmend.splice(pos, 1);
      if (this.appraisal.processingTransactionsResult.transactionsToAmend.length === 0) {
        this.extendedEntity = undefined;
      }
    }
  }
};
</script>

<style scoped>
.tag-and-counter {
  display: inline-flex;
}
.text-not-underline {
  text-decoration: none !important;
}
.entity-main-data {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;
}
.entity-main-data .item {
  display: grid;
  justify-content: stretch;
  margin: 0;
}
.entity-main-data .item .title {
  font-size: 0.8rem;
  margin: 0;
}

.entity-detailed-data {
  width: 100%;
  max-height: 0px;
  height: auto;
  overflow: hidden;
  background-color: #f9f9f9;
  border-radius: 20px;
  padding: 0 30px;
  margin: 0px auto auto;
  font-size: 14px;
}
.entity-details {
  display: grid;
  gap: 0.3rem 1rem;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-columns: repeat(5, minmax(150px, 1fr));
  grid-template-areas: "col1 col2 col3";
  text-align: center;
  font-size: 0.8rem;
}
.entity-details .item {
  display: flex;
  align-items: left;
  margin: auto;
}
.entity-details .item .title {
  font-size: 0.7rem;
  margin: 0;
}
.show {
  margin-top: 10px;
  padding: 20px;
  max-height: 600px;
  overflow-y: auto;
}
.is-disabled {
  opacity: 0.5;
}
.rotate {
  transform: rotate(180deg);
}

@media (max-width: 640px) {
  .entity-main-data {
    display: block;
    text-align: center;
  }
  .entity-main-data > div {
    margin-bottom: 10px;
    display: block;
  }
  .entity-main-data .item {
    display: block;
    justify-content: stretch;
    margin-bottom: 10px;
  }
  .entity-main-data .item > span {
    margin-left: 5px;
  }
  .movement-type.field.is-grouped {
    display: block;
  }
  .entity-details {
    grid-template-columns: repeat(1, 1fr);
    grid-template-areas: "col1";
  }
  .entity-details .item {
    display: inline-block;
    width: 100%;
    align-items: center;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    text-align: center;
    padding: 5px;
  }
  .entity-details .item .button{
    display: inline-block;
    width: 100%;
  }
}
</style>
